import { ErrorInfo } from "react"

import { isTosException } from "@src/api/user"
import { reportError } from "@src/utils/reportError"

/**
 * Router `defaultOnCatch`: called once per error caught by a route's
 * CatchBoundary (render and loader errors). The ToS error is a prompt, not a
 * crash, so it isn't reported.
 */
export const reportRouteError = (error: unknown, errorInfo?: ErrorInfo) => {
  if (isTosException(error)) return
  reportError(error, "router", errorInfo?.componentStack)
}
